// curl -X 'GET' \
//   'https://api-developers.jago.cloud/api/v2/users?page=0&pageSize=10&roleIds=0&roleIds=1&roleIds=2&orderDir=DESC&orderBy=id' \
//   -H 'accept: */*'

import { useState } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import useLogin from './useLogin';


const useLog = () =>{
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { logout } = useLogin();

    const token = useSelector((state)=>state.user.itoken);
    //const itoken = useSelector((state)=>state.user.itoken);

    const HOST = process.env.REACT_APP_API_MIDDLEWARE_URL;
    const MIDDLEWARE_HOST = process.env.REACT_APP_API_MIDDLEWARE_URL;

    const dispatch = useDispatch();

    const getOpenLogsIn24h = async(doorId,onSuccess,onError,page=0,pageSize=200,repeat=true) =>{
        const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
        };
      try {
        setLoading(true);
        const now = new Date();
        const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);

        axios.get(
            `${HOST}/api/v2/logs/smartLockEvents?page=${page}&pageSize=${pageSize}&fromDate=${yesterday.getTime()}&toDate=${now.getTime()}&smartLockId=${doorId}&eventType=JAGO_0`,
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200){
                if(repeat && response.data.totalPages > 1){
                    let data = {content:[...response.data.content]};
                    for(let i = 1; i < response.data.totalPages;i++){
                        console.log(i)
                        getOpenLogsIn24h(
                            doorId,
                            (res)=>{
                                data.content = [...data.content,...res.content]
                            },
                            (error)=>{toast.error(`Errore log pagina ${i}`)},
                            i,
                            200,
                            false
                        )

                    }
                    onSuccess(data)
                }else{
                    onSuccess(response.data);
                }
            }else{
              if(response.status === 401){
                logout();
              }
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            if(error.response?.status === 401){
                logout();
            }
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }

    }

    const getUserInside = async(doorId,onSuccess,onError) =>{
      const headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin' : '*',
        'Access-Control-Allow-Headers' : 'Origin, X-Requested-With, Content-Type, Accept',
        'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        Authorization: `Bearer ${token}`
      };

      try {
        setLoading(true);
        axios.get(
            `${MIDDLEWARE_HOST}/api/v1/events/${doorId}/users`,
            {headers}
        ).then(
          (response) => {
            if(response.status === 200){
                onSuccess(response.data);
            }else{
              if(response.status === 401){
                logout();
              }
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            if(error.response?.status === 401){
                logout();
            }
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }
    }

    const getHistoryLogs = async(params,onSuccess,onError) =>{
      const headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin' : '*',
        'Access-Control-Allow-Headers' : 'Origin, X-Requested-With, Content-Type, Accept',
        'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        Authorization: `Bearer ${token}`
      };

      try {
        setLoading(true);
        axios.get(
            `${MIDDLEWARE_HOST}/api/v1/events/${params.doorId}?from=${params.startDate}&to=${params.endDate}`,
            {headers}
        ).then(
          (response) => {
            if(response.status === 200){
                onSuccess(response.data);
            }else{
              if(response.status === 401){
                logout();
              }
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            if(error.response?.status === 401){
                logout();
            }
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }
    }

    const getApplicationLogs = async(username,onSuccess,onError) =>{
      const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
        };
      try {
        setLoading(true);
        const now = new Date();
        const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);

        axios.get(
            `${HOST}/api/v1/logs?username=${username}`,
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200){
                    onSuccess(response.data);
            }else{
                if(response.status === 401){
                  logout();
                }
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            if(error.response?.status === 401){
                logout();
            }
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi. [getApplicationLogs]`)
      }

    }




    return { getOpenLogsIn24h, getUserInside, getHistoryLogs, getApplicationLogs, logLoading:loading, userError:error };
};

export default useLog;